var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tipsStatus)?_c('div',{staticClass:"tipsFixed"},[_vm._v(_vm._s(_vm.tipsText))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }